import React, { useCallback, useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useSite } from "../lib/site";
import useSeo from "../hooks/useSeo";
import { captureAttribution, trackRacex } from "../components/racex/racex";
import { RacexHeader, RacexFooter } from "../components/racex/RacexShell";
import { RacexHero } from "../components/racex/RacexHero";
import { RacexDetails, RacexFaq } from "../components/racex/RacexDetails";
import { RacexGallery, RacexFilm } from "../components/racex/RacexMedia";
import { RacexEnquiry } from "../components/racex/RacexEnquiry";
import { RacexReel } from "../components/racex/RacexReel";
import "../components/racex/racex.css";
import "../components/racex/racex-racing.css";
import "../components/racex/racex-sections.css";

export default function RacexTownsville() {
  const { site } = useSite();
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(false);
  const [film, setFilm] = useState(false);
  const [attribution] = useState(captureAttribution);
  const viewed = useRef(false);
  useSeo({ title: "RACEX Townsville | NQ Springs Exclusive Pricing", description: "Nine laps. A 650HP V8. You at the wheel. Discover NQ Springs exclusive RACEX Townsville pricing and enquire directly with our team.", canonical: "/racex-townsville" });
  const load = useCallback(async () => {
    setError(false);
    try { const { data } = await api.get("/events/racex"); setEvent(data); }
    catch { setError(true); }
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => { if (event && !viewed.current) { viewed.current = true; trackRacex("page_view"); } }, [event]);
  const watch = () => { trackRacex("film_open"); setFilm(true); };
  return <div className="rx-page rx-racing" data-testid="racex-page"><a href="#racex-main" className="rx-skip" data-testid="racex-skip-link">Skip to event</a><RacexHeader site={site} event={event} />
    <main id="racex-main">
      {!event ? <div className="rx-loading" role={error ? "alert" : "status"} data-testid="racex-loading-state">{error ? <><h1>Event details are temporarily unavailable.</h1><p>Please try again.</p><button className="rx-button" onClick={load} data-testid="racex-retry-button">Try again</button></> : <><Loader2 className="animate-spin" /><span>Getting race-day ready…</span></>}</div> : <><RacexHero event={event} onWatch={watch} /><RacexDetails event={event} /><RacexReel event={event} onWatch={watch} /><RacexEnquiry event={event} contact={site?.contact} attribution={attribution} /><RacexGallery onWatch={watch} /><RacexFaq event={event} contact={site?.contact} /></>}
    </main>
    <RacexFooter site={site} event={event} /><RacexFilm open={film} onOpenChange={setFilm} />
  </div>;
}